import * as constants from '../../../vendor/cdt/checkout/src/checkout-web/src/scripts/config/constants.js';
import Selectors from '../../../vendor/cdt/checkout/src/checkout-web/src/scripts/utils/selectors.js';
import ElementClassHandler from '../../../vendor/cdt/checkout/src/checkout-web/src/scripts/utils/element-class-handler.js';
import FormFieldHandler from '../../../vendor/cdt/checkout/src/checkout-web/src/scripts/utils/form-field-handler.js';
import ResponseHandler from '../../../vendor/cdt/checkout/src/checkout-web/src/scripts/utils/response-handler.js';
import RequestHandler from '../../../vendor/cdt/checkout/src/checkout-web/src/scripts/utils/request-handler.js';
import MDLFormFields from '../../../vendor/cdt/checkout/src/checkout-web/src/scripts/utils/mdl-form-fields.js';
import FormValidator from '../../../vendor/cdt/checkout/src/checkout-web/src/scripts/form-validator.js';
import LoadingOverlay from './../loading-overlay.js';

const REQUIRED_MONTHS = 36;

export default class Address {
    constructor(options = {}) {
        this.multipleAddresses = options.multipleAddresses || false;
        this.durationFields = options.durationFields || false;
        this.addressType = options.addressType || '';
        this.elementIdentifier = options.elementIdentifier || '';
        this.manualFormPrefix = options.manualForm;
        this.manualForm = options.manualForm;
        this.searchForm = options.searchForm;
        this.selectors = new Selectors({
            dataAttrId: 'data-address-id'
        });
        this.formValidator = new FormValidator();
        this.container = document.querySelector(this.selectors.dataAttr(this.elementIdentifier + '_block'));
        this.deleteModal = this.elementIdentifier + '_modal';
        this.errorMessage = this.elementIdentifier + '_error';
        this.addressSearchResults = this.elementIdentifier + '_search_results';
        this.addressSearchMessage = this.elementIdentifier + '_search_message';
        this.manualAddressLink = this.elementIdentifier + '_manual_link';
        this.searchAddressLink = this.elementIdentifier + '_search_link';
        this.myAddressList = this.elementIdentifier + '_list';
        this.searchAddressBlock = this.elementIdentifier + '_search_block';
        this.searchAddressButton = this.elementIdentifier + '_find_address_button';
        this.searchAddressDurationBlock = this.elementIdentifier + '_search_duration_block';
        this.addAddressBlock = this.elementIdentifier + '_add_block';
        this.addAddressButton = this.elementIdentifier + '_add_address_button';
        this.updateAddressBlock = this.elementIdentifier + '_update_block';
        this.manualAddressBlock = this.elementIdentifier + '_manual_block';
        this.manualAddressDurationBlock = this.elementIdentifier + '_manual_duration_block';
        this.cancelUpdateAddress = this.elementIdentifier + '_cancel_update';
        this.manualAddressIndex = this.elementIdentifier + '_index';
        this.collectionBlock = this.elementIdentifier + '_collection_block';
        this.configAttribute = 'data-address-config';
        this.nonStandardPostcodeMessage = 'non_standard_postcode_message';
        this.slotPicker = 'slot_picker';
        this.collectionIdentifier = 'data-address-collection-id';
        this.css = {
            currentAddressAdded: 'current-address-added',
            editingCurrentAddress: 'editing-current-address'
        };
        this.myAddresses = [];
        this.matchingAddresses = [];
        this.responseHandler = new ResponseHandler;
        this.requestHandler = new RequestHandler;
        this.elementClassHandler = new ElementClassHandler;
        this.mdlFormFields = new MDLFormFields;
        this.formFieldHandler = new FormFieldHandler;
        this.nonRequiredFields = [
            this.elementIdentifier + '_search_form_houseNumberName',
            this.elementIdentifier + '_manual_form_property',
            this.elementIdentifier + '_manual_form_locality',
            this.elementIdentifier + '_manual_form_county',
        ];
        this.loadingOverlay = new LoadingOverlay;
        this.requiredHistory = REQUIRED_MONTHS;
        this.checkbox = this.selectors.nameAttr('form[' + options.enableForm + '][enabled]');
        this.useBillingAddressAsDeliveryAddress = 'useBillingAddressAsDeliveryAddress';
        this.geoPostcodeLookupHostname = null;
    }

    setup() {
        document.addEventListener('DOMContentLoaded', () => {
            this.startLoad();
        });
        this.readConfig();
        this.myAddressesApi();
        this.getManualFormToken();
        this.setupSearchResultsListeners();
        this.setupSearchAddressLinkListener();
        this.setupManualAddressLinkListener();
        this.setupSearchAddressButtonListener();
        this.setupSearchInputListener();
        this.setupAddAddressButtonListener();
        this.setupUpdateAddressButtonListener();
        this.setupCancelAddressButtonListener();
        this.setupFormSubmitListener();
        if (this.multipleAddresses) {
            this.elementClassHandler.hide(document.querySelector(this.selectors.dataAttr(this.collectionBlock)));
            this.setRequiredFields(this.selectors.querySelectorArray(this.selectors.attrSelector('type', 'text'), this.container), this.nonRequiredFields);
        }
        this.setupGeoPostcodeLookupHostname();
        this.setupPostCode();
    }

    startLoad() {
        this.elementClassHandler.add(this.container, constants.SPINNER_ACTIVE);
        this.elementClassHandler.add(this.container, 'hide-inner');
        setTimeout(() => {
            if (document.querySelector('.' + constants.SPINNER_ACTIVE)) {
                this.endLoad();
            }
        }, 2000);
    }

    endLoad() {
        this.elementClassHandler.remove(this.container, constants.SPINNER_ACTIVE);
        this.elementClassHandler.remove(this.container, 'hide-inner');
    }

    showError(error, elem = null) {
        const errorBox = elem ? elem : document.querySelector(this.selectors.dataAttr(this.errorMessage));
        errorBox.innerHTML = error;
        this.elementClassHandler.show(errorBox);
        this.elementClassHandler.alertError(errorBox);
    }

    hideError(elem = null) {
        const errorBox = elem ? elem : document.querySelector(this.selectors.dataAttr(this.errorMessage));
        this.elementClassHandler.removeAlerts(errorBox);
        this.elementClassHandler.hide(errorBox);
    }

    getManualFormToken() {
        this.manualFormToken = document.querySelector(this.selectors.nameAttr(this.manualFormPrefix + '[_token]')).value || '';
    }

    myAddressesApi() {
        this.requestHandler.get(
            constants.CHECKOUTPATH + '/' + this.addressType + '/list', '', this.myAddressesApiCallBack.bind(this)
        );
    }

    postcodeToUpper(selector) {
        let postcodeField = document.querySelector(selector);
        if (postcodeField) {
            postcodeField.value = postcodeField.value.toUpperCase();
        }
    }

    formatCollectionId(address) {
        return address.houseNumber.trim() + ',' + (address.postcode.replace(' ', '').toUpperCase());
    }

    checkAddressUnique(address) {
        let newAddressId = this.formatCollectionId(address),
            existingAddressSelector = this.selectors.attrSelector(this.collectionIdentifier, newAddressId),
            error = 'You have already entered this address';

        if (this.addressType === 'billing-address') {
            let billingAddressesSelector = this.selectors.attrSelector('data-address-id', 'billing_address_list') + ' ' + this.selectors.attrSelector('data-address-collection-id'),
                addressIndexToCheck = this.selectors.querySelectorArray(billingAddressesSelector).length - 1;

            existingAddressSelector = this.selectors.dataAttr('my_billing_address_' + addressIndexToCheck) + ' ' + this.selectors.attrSelector(this.collectionIdentifier, newAddressId);
            error = 'This address matches the one immediately above';
        }

        if (!this.multipleAddresses) {
            existingAddressSelector = this.selectors.dataAttr('my_billing_address_0') + ' ' + this.selectors.attrSelector(this.collectionIdentifier, newAddressId);
            error = 'Please select a different address for delivery';
        }

        let existingAddress = this.selectors.querySelectorArray(existingAddressSelector);

        if (existingAddress.length) {
            this.showError('<span class="msg-box-icon"></span>' + error);
        } else {
            this.hideError();
            return true;
        }
    }

    setRequiredFields(fields, exceptions = []) {
        let self = this;
        fields.forEach((el) => {
            if (!(exceptions.indexOf(el.id) > -1) && !el.hasAttribute('required')) {
                let label = el.parentNode.querySelector('label');
                el.setAttribute('required', 'required');
                self.elementClassHandler.add(label, 'required');
                componentHandler.upgradeElement(el);
            }
        });
    }

    removeRequiredFields(fields = null, exceptions = []) {
        let self = this,
            requiredFields = fields || this.selectors.querySelectorArray(this.selectors.attrSelector('type', 'text'), this.container);
        requiredFields.forEach((el) => {
            if (!(exceptions.indexOf(el.id) > -1) && el.hasAttribute('required')) {
                let label = el.parentNode.querySelector('label'),
                    labelRequired = label.querySelector('.required-label');
                el.removeAttribute('required');
                self.elementClassHandler.remove(label, 'required');
                if (labelRequired) {
                    label.removeChild(labelRequired);
                }
                componentHandler.upgradeElement(el);
            }
        });
    }

    toggleRequiredFields(type = 'search') {
        let searchRequiredInputs = this.selectors.querySelectorArray(this.selectors.dataAttr(this.searchForm) + ' ' + this.selectors.attrSelector('type', 'text'), this.container),
            manualRequiredInputs = this.selectors.querySelectorArray(this.selectors.dataAttr(this.manualForm) + ' ' + this.selectors.attrSelector('type', 'text'), this.container),
            enableRequiredInputs = (type == 'search') ? searchRequiredInputs : manualRequiredInputs,
            disableRequiredInputs = (type == 'search') ? manualRequiredInputs : searchRequiredInputs;
        this.setRequiredFields(enableRequiredInputs, this.nonRequiredFields);
        this.removeRequiredFields(disableRequiredInputs);
    }

    setupSearchResultsChangeListener() {
        document.querySelector(this.selectors.dataAttr(this.addressSearchResults) + ' select').addEventListener('change', (e) => {
            if (e.target.value == 'Select Address') {
                return;
            }
            const address = this.matchingAddresses[e.target.value] || [];
            if (address.houseNumber && address.postcode && !this.checkAddressUnique(address)) {
                return;
            }
            if (this.multipleAddresses && address.years == 0 && address.months == 0) {
                return;
            }
            this.elementClassHandler.hide(document.querySelector(this.selectors.dataAttr(this.addressSearchResults)));
            this.clearAddressSearchMessage();
            this.loadingOverlay.taskStarted();
            this.requestHandler.get(
                this.geoPostcodeLookupHostname + '/address/' + e.target.value,
                null,
                this.fetchAddressApiCallBack.bind(this)
            );
        });
    }

    setupGeoPostcodeLookupHostname() {
        const el = document.querySelector('[data-geo-postcode-lookup-hostname]');
        if (el && el.hasAttribute('data-geo-postcode-lookup-hostname')) {
            this.geoPostcodeLookupHostname = el.getAttribute('data-geo-postcode-lookup-hostname').replace(/\/$/g, '');
        } else {
            this.geoPostcodeLookupHostname = 'https://geo.simplifyprod.co.uk';
        }
    }

    setupCancelSearchButtonListener() {
        const element = document.querySelector(this.selectors.dataAttr(this.addressSearchResults) + ' button') || null;
        if (element) {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                this.clearSearchForm();
                this.elementClassHandler.hide(document.querySelector(this.selectors.dataAttr(this.addressSearchResults)));
                this.clearAddressSearchMessage();
                this.validateMyAddressList();
            });
        }
    }

    setupSearchResultsListeners() {
        this.setupSearchResultsChangeListener();
        this.setupCancelSearchButtonListener();
    }

    setupSearchAddressButtonListener() {
        const element = document.querySelector(this.selectors.dataAttr(this.searchAddressButton) + ' button') || null;
        if (element) {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                this.clearAddressDeleteMessage();
                this.matchingAddresses = [];
                this.postcodeToUpper('#' + this.elementIdentifier + '_search_form_postcode');
                let address = this.formToCollectionId(this.searchForm);

                if (address.houseNumber && address.postcode && !this.checkAddressUnique(address)) {
                    return;
                }
                if (this.multipleAddresses && address.years == 0 && address.months == 0) {
                    return;
                }
                this.loadingOverlay.taskStarted();

                var data = {
                    query: address.postcode
                };

                this.requestHandler.get(
                    // NOTE: proxy is needed for the dev version
                    this.geoPostcodeLookupHostname + '/address/search',
                    data,
                    this.getAddressSearchApiCallBack.bind(this)
                );
            });
        }
    }

    setupSearchInputListener() {
        const button = document.querySelector(this.selectors.dataAttr(this.searchAddressButton) + ' button');
        let searchPropertyInputs = this.selectors.querySelectorArray(this.selectors.dataAttr(this.searchAddressBlock) + ' input'),
            searchDurationInputs = this.selectors.querySelectorArray(this.selectors.dataAttr(this.searchAddressDurationBlock) + ' input'),
            searchAddressInputs = searchPropertyInputs.concat(searchDurationInputs),
            self = this;
        if (button && searchAddressInputs) {
            this.checkDisableAddressButton(button, searchAddressInputs);
            searchAddressInputs.forEach((el) => {
                let disableFindAttr = 'data-check-disabled-find';
                if (!el.hasAttribute(disableFindAttr)) {
                    el.addEventListener('input', () => {
                        self.checkDisableAddressButton(button, searchAddressInputs);
                    });
                    el.setAttribute(disableFindAttr, '1');
                }
            });
        }
    }

    setupManualInputListener() {
        const button = document.querySelector(this.selectors.dataAttr(this.addAddressButton) + ' button');
        let manualPropertyInputs = this.selectors.querySelectorArray(this.selectors.dataAttr(this.manualAddressBlock) + ' input'),
            manualDurationInputs = this.selectors.querySelectorArray(this.selectors.dataAttr(this.manualAddressDurationBlock) + ' input'),
            manualAddressInputs = manualPropertyInputs.concat(manualDurationInputs),
            self = this;
        if (button && manualAddressInputs) {
            this.checkDisableAddressButton(button, manualAddressInputs);
            manualAddressInputs.forEach((el) => {
                let disableFindAttr = 'data-check-disabled-find';
                if (!el.hasAttribute(disableFindAttr)) {
                    el.addEventListener('input', () => {
                        self.checkDisableAddressButton(button, manualAddressInputs);
                    });
                    el.setAttribute(disableFindAttr, '1');
                }
            });
        }
    }

    setupAddAddressButtonListener() {
        const element = document.querySelector(this.selectors.dataAttr(this.addAddressButton) + ' button') || null;
        if (element) {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                this.addManualAddress();
            });
        }
    }

    setupUpdateAddressButtonListener() {
        const element = document.querySelector(this.selectors.dataAttr(this.updateAddressBlock) + ' button') || null;
        if (element) {
            element.addEventListener('click', (e) => {
                let addressIndex = document.querySelector(this.selectors.dataAttr(this.manualAddressIndex)).value;
                e.preventDefault();
                this.postcodeToUpper('#' + this.elementIdentifier + '_manual_form_postcode');
                this.clearAddressDeleteMessage();
                this.requestHandler.post(constants.CHECKOUTPATH + '/' + this.addressType + '/update' +
                    (this.multipleAddresses ? '/' + addressIndex : ''),
                this.formFieldHandler.getFormValues(this.selectors.dataAttr(this.manualForm)),
                this.updateAddressApiCallBack.bind(this)
                );
            });
        }
    }

    setupCancelAddressButtonListener() {
        const element = document.querySelector(this.selectors.dataAttr(this.cancelUpdateAddress)) || null,
            addressIndex = document.querySelector(this.selectors.dataAttr(this.manualAddressIndex)).value;
        if (element) {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                this.clearManualForm();
                this.validateMyAddressList();
                if (addressIndex == 0 && this.multipleAddresses) {
                    this.elementClassHandler.remove(this.container, this.css.editingCurrentAddress);
                }
            });
        }
    }

    setupFormSubmitListener() {
        const form = document.querySelector('[' + this.selectors.dataAttrId + ']').closest('form');
        if (form && !form.dataset.hasSubmitListener) {
            form.addEventListener('submit', (event) => {
                if (this.isManualBillingAddressPending()) {
                    event.preventDefault();
                    form.dataset.queuedForSubmit = true;
                    this.addManualAddress();
                }
            });
            form.dataset.hasSubmitListener = true;
        }
    }

    isManualBillingAddressPending() {
        const button = document.querySelector(this.selectors.dataAttr(this.addAddressButton) + ' button');
        return button.dataset.isPending;
    }

    addManualAddress() {
        this.postcodeToUpper('#' + this.elementIdentifier + '_manual_form_postcode');
        let address = this.formToCollectionId(this.manualForm);
        if (address.houseNumber && address.postcode && !this.checkAddressUnique(address)) {
            return;
        }
        if (this.multipleAddresses && address.years == 0 && address.months == 0) {
            return;
        }
        this.clearAddressDeleteMessage();
        this.loadingOverlay.taskStarted();
        let formData = this.formFieldHandler.getFormValues(this.selectors.dataAttr(this.manualForm));
        formData[this.useBillingAddressAsDeliveryAddress] = document.querySelector(this.checkbox).checked === true;
        this.requestHandler.post(
            constants.CHECKOUTPATH + '/' + this.addressType + '/add',
            formData,
            this.addAddressApiCallBack.bind(this)
        );
    }

    setupManualAddressLinkListener() {
        const element = document.querySelector(this.selectors.dataAttr(this.manualAddressLink)) || null;
        if (element) {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                this.activateManualAddressForm();
            });
        }
    }

    activateManualAddressForm() {
        this.clearSearchForm();
        this.clearAddressDeleteMessage();
        if (this.durationFields) {
            const heading = document.querySelector(this.selectors.dataAttr(this.searchAddressDurationBlock) + ' [data-address-heading]');
            this.elementClassHandler.remove(heading, 'bounce');
            this.elementClassHandler.remove(heading, 'infinite');
        }
        this.elementClassHandler.hide(document.querySelector(this.selectors.dataAttr(this.addressSearchResults)));
        this.showBlocks([this.manualAddressBlock, this.addAddressBlock, this.manualAddressDurationBlock]);
        this.toggleRequiredFields('manual');
        this.setupManualInputListener();
    }

    setupSearchAddressLinkListener() {
        const element = document.querySelector(this.selectors.dataAttr(this.searchAddressLink)) || null;
        if (element) {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                this.clearAddressDeleteMessage();
                this.clearManualForm();
                this.showBlocks([this.searchAddressBlock, this.searchAddressDurationBlock]);
                this.toggleRequiredFields();
            });
        }
    }

    formToCollectionId(element) {
        const container = document.querySelector(this.selectors.dataAttr(element));
        let result = {},
            houseNumberElem = container.querySelector(this.selectors.attrSelector('name', element + '[houseNumberName]'));

        if (!houseNumberElem) {
            houseNumberElem = container.querySelector(this.selectors.attrSelector('name', element + '[houseNumber]'));
        }

        result.houseNumber = houseNumberElem.value;
        result.postcode = container.querySelector(this.selectors.attrSelector('name', element + '[postcode]')).value;

        if (this.multipleAddresses) {
            result.months = document.querySelector(this.selectors.nameAttr(element + '[months][months]')).value;
            result.years = document.querySelector(this.selectors.nameAttr(element + '[months][years]')).value;
        }

        return result;
    }

    myAddressesApiCallBack(response) {
        if (this.responseHandler.isSuccess(response)) {
            const myAddresses = this.responseHandler.getData(response) || [];
            this.clearAddressesFromCollection();
            myAddresses.forEach((item) => {
                if (item['postcode']) {
                    this.addMyAddress(item);
                }
            });
            this.validateMyAddressList(false);
            componentHandler.upgradeDom();
        } else {
            console.error(this.responseHandler.getErrors(response), 'myAddressesApiCallBack Error');
        }
    }

    getAddressSearchApiCallBack(response) {
        let address = this.formToCollectionId(this.searchForm);

        this.clearAddressSearchMessage();

        if (Array.isArray(response)) {
            let filteredAddress = this.filterAddressesByHouseNumberName(response, address.houseNumber);
            if (filteredAddress) {
                this.matchingAddresses = [filteredAddress];
            } else {
                this.matchingAddresses = response;
            }
            this.handleAddressSearchResults();
        } else {
            this.elementClassHandler.hide(document.querySelector(this.selectors.dataAttr(this.addressSearchResults)));
        }
        this.formValidator.setupRemoveErrorEventListeners();
        this.formValidator.forceNumberOnlyFields();
        this.setupManualAddressLinkListener();
        this.setupSearchInputListener();
        componentHandler.upgradeDom();
        this.loadingOverlay.taskFinished();
    }

    fetchAddressApiCallBack(address) {
        if (this.multipleAddresses) {
            address['years'] = document.querySelector(this.selectors.nameAttr(this.searchForm + '[months][years]')).value;
            address['months'] = document.querySelector(this.selectors.nameAttr(this.searchForm + '[months][months]')).value;
        }

        this.requestHandler.post(constants.CHECKOUTPATH + '/' + this.addressType + '/add',
            this.constructManualFormDataFromAddressLookup(address),
            this.addAddressApiFromSearchCallBack.bind(this)
        );
    }

    filterAddressesByHouseNumberName(addresses, houseNumberName) {
        const pattern = new RegExp('^' + houseNumberName + ', |^' + houseNumberName + ' ', 'i');
        for (let address of addresses) {
            if (pattern.test(address.address)) {
                return address;
            }
        }
        return null;
    }

    addAddressApiFromSearchCallBack(response) {
        document.querySelector(this.selectors.dataAttr(this.manualAddressBlock)).innerHTML = this.responseHandler.getFormAddress(response);
        if (this.durationFields) {
            document.querySelector(this.selectors.dataAttr(this.manualAddressDurationBlock)).innerHTML = this.responseHandler.getFormDuration(response);
        }
        if (this.responseHandler.isSuccess(response)) {
            this.addMyAddress(this.getManualAddress());
            this.submitFormIfQueued();
            this.clearSearchForm();
            this.setupSearchAddressLinkListener();
            this.setupUpdateAddressButtonListener();
            this.setupAddAddressButtonListener();
            this.setupCancelAddressButtonListener();
            componentHandler.upgradeDom();
        } else {
            this.activateManualAddressForm();
        }
        this.loadingOverlay.taskFinished();
    }

    addAddressApiCallBack(response) {
        if (this.responseHandler.isSuccess(response)) {
            this.addMyAddress(this.getManualAddress());
            this.submitFormIfQueued();
        }
        document.querySelector(this.selectors.dataAttr(this.manualAddressBlock)).innerHTML = this.responseHandler.getFormAddress(response);
        if (this.durationFields) {
            document.querySelector(this.selectors.dataAttr(this.manualAddressDurationBlock)).innerHTML = this.responseHandler.getFormDuration(response);
        }
        this.formValidator.setupRemoveErrorEventListeners();
        this.formValidator.forceNumberOnlyFields();
        this.setupSearchAddressLinkListener();
        this.setupUpdateAddressButtonListener();
        this.setupAddAddressButtonListener();
        this.setupCancelAddressButtonListener();
        this.setupSearchInputListener();
        componentHandler.upgradeDom();
        this.loadingOverlay.taskFinished();
    }

    submitFormIfQueued() {
        const form = document.querySelector('[' + this.selectors.dataAttrId + ']').closest('form');
        if (form && form.dataset.queuedForSubmit) {
            form.submit();
        }
    }

    updateAddressApiCallBack(response) {
        document.querySelector(this.selectors.dataAttr(this.manualAddressBlock)).innerHTML = this.responseHandler.getFormAddress(response);
        if (this.durationFields) {
            document.querySelector(this.selectors.dataAttr(this.manualAddressDurationBlock)).innerHTML = this.responseHandler.getFormDuration(response);
        }
        if (this.responseHandler.isSuccess(response)) {
            this.updateMyAddress(this.getManualAddress());
        } else {
            this.showBlocks([this.manualAddressBlock, this.updateAddressBlock, this.manualAddressDurationBlock]);
        }
        this.formValidator.setupRemoveErrorEventListeners();
        this.formValidator.forceNumberOnlyFields();
        this.setupSearchAddressLinkListener();
        this.setupUpdateAddressButtonListener();
        this.setupAddAddressButtonListener();
        this.setupCancelAddressButtonListener();
        this.setupSearchInputListener();
        componentHandler.upgradeDom();
    }

    handleAddressSearchResults() {
        const searchResultsContainer = document.querySelector(this.selectors.dataAttr(this.addressSearchResults)),
            select = searchResultsContainer.querySelector('select');
        this.elementClassHandler.hide(searchResultsContainer);
        this.setAddressSearchMessage();
        if (this.matchingAddresses.length === 0) {
            return;
        } else if (this.matchingAddresses.length === 1) {
            const address = this.matchingAddresses[0];
            this.loadingOverlay.taskStarted();
            this.requestHandler.get(
                this.geoPostcodeLookupHostname + '/address/' + address.id,
                null,
                this.fetchAddressApiCallBack.bind(this)
            );
            return;
        }
        select.innerHTML = '';
        let defaultOption = document.createElement('option');
        defaultOption.textContent = 'Select Address';
        select.appendChild(defaultOption);

        this.matchingAddresses.map((address) => {
            let newAddress = new Option(address.address, address.id);
            select.appendChild(newAddress);
        });
        this.removeRequiredFields();
        this.elementClassHandler.hide(document.querySelector(this.selectors.dataAttr(this.searchAddressBlock)));
        if (this.multipleAddresses) {
            this.elementClassHandler.hide(document.querySelector(this.selectors.dataAttr(this.searchAddressDurationBlock)));
        }
        this.elementClassHandler.show(searchResultsContainer);
    }

    updateMyAddress(address) {
        let addressIndex = address.index || null,
            myAddressesMapped = this.myAddresses.map((item, index) => index === parseInt(addressIndex, 10) ? address : item);

        this.clearMyAddresses();
        this.clearAddressesFromCollection();
        myAddressesMapped.forEach(address => this.addMyAddress(address));
        this.validateMyAddressList();
        if (addressIndex == 0 && this.multipleAddresses) {
            this.elementClassHandler.remove(this.container, this.css.editingCurrentAddress);
        }
    }

    clearMyAddresses() {
        const list = document.querySelector(this.selectors.dataAttr(this.myAddressList));
        list.innerHTML = '';
        this.myAddresses = [];
    }

    addMyAddress(address) {
        const list = document.querySelector(this.selectors.dataAttr(this.myAddressList)),
            li = document.createElement('li'),
            addressIndex = this.myAddresses.length;
        this.hideError();
        this.clearSearchForm();
        this.createMyAddressContent(li, address, addressIndex);
        li.setAttribute('data-address-id', `my_${this.elementIdentifier}_${addressIndex}`);
        list.appendChild(li);

        document.querySelector(this.selectors.dataAttr(`edit_my_${this.elementIdentifier}_${addressIndex}`)).addEventListener('click', (e) => {
            const address = this.myAddresses[addressIndex] || {},
                getProperty = propertyName => address.hasOwnProperty(propertyName) ? address[propertyName] : '';

            e.preventDefault();

            this.clearManualForm();
            this.mdlFormFields.mdlFormFill(getProperty('property'), this.selectors.nameAttr(this.manualForm + '[property]'));
            this.mdlFormFields.mdlFormFill(getProperty('houseNumber'), this.selectors.nameAttr(this.manualForm + '[houseNumber]'));
            this.mdlFormFields.mdlFormFill(getProperty('street'), this.selectors.nameAttr(this.manualForm + '[street]'));
            this.mdlFormFields.mdlFormFill(getProperty('locality'), this.selectors.nameAttr(this.manualForm + '[locality]'));
            this.mdlFormFields.mdlFormFill(getProperty('town'), this.selectors.nameAttr(this.manualForm + '[town]'));
            this.mdlFormFields.mdlFormFill(getProperty('county'), this.selectors.nameAttr(this.manualForm + '[county]'));
            this.mdlFormFields.mdlFormFill(getProperty('postcode'), this.selectors.nameAttr(this.manualForm + '[postcode]'));

            if (document.querySelector(this.selectors.dataAttr(this.manualAddressIndex))) {
                document.querySelector(this.selectors.dataAttr(this.manualAddressIndex)).value = addressIndex;
            }

            if (this.multipleAddresses) {
                this.mdlFormFields.mdlFormFill(getProperty('years'), this.selectors.nameAttr(this.manualForm + '[months][years]'));
                this.mdlFormFields.mdlFormFill(getProperty('months'), this.selectors.nameAttr(this.manualForm + '[months][months]'));
            }

            this.showBlocks([this.manualAddressBlock, this.updateAddressBlock, this.manualAddressDurationBlock]);

            if (this.multipleAddresses) {
                if (addressIndex == 0) {
                    this.elementClassHandler.add(this.container, this.css.editingCurrentAddress);
                } else {
                    this.elementClassHandler.remove(this.container, this.css.editingCurrentAddress);
                }
                this.formValidator.forceNumberOnlyFields();
            }
            this.formValidator.setupRemoveErrorEventListeners();
            this.toggleRequiredFields('manual');
            this.setupManualInputListener();
        });

        document.querySelector(this.selectors.dataAttr(`remove_my_${this.elementIdentifier}_${addressIndex}`)).addEventListener('click', (e) => {
            let handleDelete, handleClose;

            e.preventDefault();

            handleDelete = () => {
                this.loadingOverlay.taskStarted();
                this.requestHandler.post(constants.CHECKOUTPATH + '/' + this.addressType + '/delete' +
                    (this.multipleAddresses ? '/' + addressIndex : ''),
                {},
                this.deleteAddressesApiCallBack.bind(this)
                );
                document.querySelector(this.selectors.modalDataAttr(`${this.deleteModal}_close`)).removeEventListener('click', handleClose);
                document.querySelector(this.selectors.modalDataAttr(`${this.deleteModal}_submit`)).removeEventListener('click', handleDelete);
                if (addressIndex == 0 && this.multipleAddresses) {
                    this.elementClassHandler.remove(this.container, this.css.currentAddressAdded);
                }
            };

            handleClose = () => {
                document.querySelector(this.selectors.modalDataAttr(`${this.deleteModal}_close`)).removeEventListener('click', handleClose);
                document.querySelector(this.selectors.modalDataAttr(`${this.deleteModal}_submit`)).removeEventListener('click', handleDelete);
            };

            document.querySelector(this.selectors.modalDataAttr(`${this.deleteModal}_submit`)).addEventListener('click', handleDelete);
            document.querySelector(this.selectors.modalDataAttr(`${this.deleteModal}_close`)).addEventListener('click', handleClose);
        });

        this.addAddressToCollection(address);

        this.myAddresses.push(address);
        this.elementClassHandler.show(list);
        this.validateMyAddressList(false);

        if (this.multipleAddresses) {
            this.elementClassHandler.add(this.container, this.css.currentAddressAdded);
        }
        $('#details-form').validator('update');
    }

    addAddressToCollection(address) {
        if (this.multipleAddresses) {
            const
                collectionBlock = document.querySelector(this.selectors.dataAttr(this.collectionBlock)) || null,
                prototype = collectionBlock.getAttribute('data-prototype') || null;

            if (prototype) {
                const element = document.createElement('div'),
                    baseField = 'form[billingAddressCollection][billingAddresses][' + this.myAddresses.length + ']',
                    getProperty = propertyName => address.hasOwnProperty(propertyName) ? address[propertyName] : '';

                element.innerHTML = prototype.replace(/__name__/g, this.myAddresses.length);
                collectionBlock.appendChild(element);

                this.mdlFormFields.mdlFormFill(getProperty('property'), this.selectors.nameAttr(baseField + '[property]'));
                this.mdlFormFields.mdlFormFill(getProperty('houseNumber'), this.selectors.nameAttr(baseField + '[houseNumber]'));
                this.mdlFormFields.mdlFormFill(getProperty('street'), this.selectors.nameAttr(baseField + '[street]'));
                this.mdlFormFields.mdlFormFill(getProperty('locality'), this.selectors.nameAttr(baseField + '[locality]'));
                this.mdlFormFields.mdlFormFill(getProperty('town'), this.selectors.nameAttr(baseField + '[town]'));
                this.mdlFormFields.mdlFormFill(getProperty('county'), this.selectors.nameAttr(baseField + '[county]'));
                this.mdlFormFields.mdlFormFill(getProperty('postcode'), this.selectors.nameAttr(baseField + '[postcode]'));
                this.mdlFormFields.mdlFormFill(getProperty('years'), this.selectors.nameAttr(baseField + '[months][years]'));
                this.mdlFormFields.mdlFormFill(getProperty('months'), this.selectors.nameAttr(baseField + '[months][months]'));
            }
        }
    }

    clearAddressesFromCollection() {
        const collectionBlock = document.querySelector(this.selectors.dataAttr(this.collectionBlock)) || null;

        if (this.multipleAddresses && collectionBlock) {
            collectionBlock.innerHTML = '';
        }
    }

    deleteAddressesApiCallBack(response) {
        if (this.responseHandler.isSuccess(response)) {
            const data = this.responseHandler.getData(response) || [],
                addressIndex = data['addressIndex'] || 0;

            let myAddressesFiltered = this.myAddresses.filter((item, index) => index !== parseInt(addressIndex, 10));

            this.clearMyAddresses();
            this.clearAddressesFromCollection();
            myAddressesFiltered.forEach((address) => {
                this.addMyAddress(address);
            });

            this.validateMyAddressList(false);
            this.setupSearchInputListener();
            this.toggleRequiredFields();
            if ($('.addressBlock').length) {
                $('.addressBlock').each(function() {
                    if ($(this).hasClass('hide')) {
                        $(this).removeClass('hide');
                    }
                });
            }
        } else {
            const element = document.querySelector(this.selectors.dataAttr(this.errorMessage));
            this.elementClassHandler.show(element);
            element.innerHTML = 'Could not delete address details';
        }
        this.loadingOverlay.taskFinished();
    }

    createMyAddressContent(element, address, addressIndex) {
        let div, ul, addressHeading = 'Shipping Address', addressYears = address['years'], addressMonths = address['months'];

        if (this.multipleAddresses) {
            addressHeading = addressIndex === 0 ? 'Billing Address' : 'Previous Address';
        }

        this.appendNode(element, 'span', addressHeading + `<a data-address-id="${`remove_my_${this.elementIdentifier}_${addressIndex}`}" data-toggle="modal"
                data-target='${this.selectors.modalDataAttr(this.deleteModal)}' href="#" class="remove-address brand-hi-sky-text pull-right">Remove</a>`, 'remove-address'
        );

        div = this.appendNode(element, 'div', '', 'address-box');
        ul = this.appendNode(div, 'ul');

        div.setAttribute(this.collectionIdentifier, this.formatCollectionId(address));

        this.appendNode(ul, 'li', `<span><strong>Duration:</strong> ${addressYears > 0 ? addressYears + ' year' : ''}${addressYears > 1 ? 's' : ' '} ${addressMonths > 0 ? addressMonths + ' month' : ''}${addressMonths > 1 ? 's' : ''}</span>`, 'duration');

        Object.keys(address).forEach((key) => {
            if (address[key]) {
                let houseNumber = address['houseNumber'];
                switch (key) {
                    case 'street':
                        this.appendNode(ul, 'li', (houseNumber ? houseNumber + '&nbsp;' : '') + address[key], key);
                        break;
                    case 'property':
                    case 'locality':
                    case 'town':
                    case 'county':
                    case 'postcode':
                        this.appendNode(ul, 'li', address[key], key);
                        break;
                }
            }
        });

        this.appendNode(div, 'span',
            `<a data-address-id="edit_my_${this.elementIdentifier}_${addressIndex}"
            href="#" class="edit-address brand-hi-sky-text pull-left">Edit</a> `, ''
        );
    }

    addAddressHistoryLength() {
        const list = document.querySelector(this.selectors.dataAttr(this.myAddressList));
        let addressHistoryTotal = document.createElement('li'),
            totalMonths = 0,
            yearsAtAddress = 0,
            monthsAtAddress = 0,
            requiredHistoryWarning = document.querySelector('[data-address-id="billing_address_required_history_warning"]'),
            requiredHistoryWarningIcon = document.querySelector('[data-address-id="billing_address_required_history_warning_icon"]'),
            timeAtAddressElement = document.querySelector('#billing_address_search_form_months_row');
        this.myAddresses.forEach((address) => {
            totalMonths += (parseInt(address.years, 10) ? parseInt(address.years, 10) * 12 : 0) +
                parseInt(address.months, 10);
        });
        yearsAtAddress = totalMonths / 12;
        monthsAtAddress = totalMonths % 12;
        addressHistoryTotal.setAttribute('id', 'address-history-total');
        addressHistoryTotal.setAttribute('class', 'address-history-total col-sm-9 col-md-7 margin-bottom-plus-5px');

        if (list && list.firstChild && list.firstChild.hasAttribute('data-address-id')) {
            list.insertBefore(addressHistoryTotal, list.firstChild);
        }
        if (totalMonths > 0) {
            document.getElementById('address-history-total').innerHTML = '<strong>Address history total:</strong> <span class="pull-right '
                + (totalMonths >= this.requiredHistory ? 'brand-erminto-text' : 'brand-pale-red-text') + '">'
                + (Math.floor(yearsAtAddress) > 0 ? Math.floor(yearsAtAddress) + ' year' + (Math.floor(yearsAtAddress) == 1 ? ' ' : 's ') : '')
                + (monthsAtAddress > 0 ? monthsAtAddress + ' month' + (monthsAtAddress == 1 ? '' : 's') : '')
                + '</span>';
        }
        if (timeAtAddressElement) {
            if (totalMonths == 0 || totalMonths >= this.requiredHistory) {
                requiredHistoryWarning.setAttribute('class', 'msg-box msg-box-caution');
                requiredHistoryWarningIcon.setAttribute('class', 'block brand-duran-icon info-circle pull-left');
            } else {
                requiredHistoryWarning.setAttribute('class', 'msg-box msg-box-error');
                requiredHistoryWarningIcon.setAttribute('class', 'block brand-pale-red-icon warning-sign pull-left');
            }
        }
    }

    appendNode(element, type, content = '', className = '') {
        const node = document.createElement(type);
        if (content) {
            node.innerHTML = content;
        }
        if (className) {
            this.elementClassHandler.add(node, className);
        }
        element.appendChild(node);

        return node;
    }

    getManualAddress() {
        const index = document.querySelector(this.selectors.dataAttr(this.manualAddressIndex)) || null,
            years = document.querySelector(this.selectors.nameAttr(this.manualForm + '[months][years]')) || null,
            months = document.querySelector(this.selectors.nameAttr(this.manualForm + '[months][months]')) || null;

        return {
            'property': document.querySelector(this.selectors.nameAttr(this.manualForm + '[property]')).value,
            'houseNumber': document.querySelector(this.selectors.nameAttr(this.manualForm + '[houseNumber]')).value,
            'street': document.querySelector(this.selectors.nameAttr(this.manualForm + '[street]')).value,
            'locality': document.querySelector(this.selectors.nameAttr(this.manualForm + '[locality]')).value,
            'town': document.querySelector(this.selectors.nameAttr(this.manualForm + '[town]')).value,
            'county': document.querySelector(this.selectors.nameAttr(this.manualForm + '[county]')).value,
            'postcode': document.querySelector(this.selectors.nameAttr(this.manualForm + '[postcode]')).value,
            'index': index ? index.value : null,
            'years': years ? years.value : null,
            'months': months ? months.value : null
        };
    }

    showBlocks(blocks) {
        this.startLoad();
        this.elementClassHandler.hideElements(this.selectors.querySelectorArray(this.selectors.dataAttr(this.searchAddressBlock)));
        this.elementClassHandler.hideElements(this.selectors.querySelectorArray(this.selectors.dataAttr(this.manualAddressBlock)));
        if (this.durationFields) {
            this.elementClassHandler.hideElements(this.selectors.querySelectorArray(this.selectors.dataAttr(this.searchAddressDurationBlock)));
            this.elementClassHandler.hideElements(this.selectors.querySelectorArray(this.selectors.dataAttr(this.manualAddressDurationBlock)));
        }
        this.elementClassHandler.hide(document.querySelector(this.selectors.dataAttr(this.updateAddressBlock)));
        this.elementClassHandler.hide(document.querySelector(this.selectors.dataAttr(this.addAddressBlock)));
        blocks.forEach((block) => {
            if (block === this.searchAddressBlock || block === this.manualAddressBlock) {
                this.elementClassHandler.showElements(this.selectors.querySelectorArray(this.selectors.dataAttr(block)));
            } else if (this.durationFields || (block !== this.searchAddressDurationBlock && block !== this.manualAddressDurationBlock)) {
                this.elementClassHandler.show(document.querySelector(this.selectors.dataAttr(block)));
            }
        });
        this.endLoad();
    }

    validateMyAddressList(condition = true) {
        if ($('#address-history-total').length) {
            this.showBlocks([]);
            this.removeRequiredFields();
            if ($('.addressBlock').length) {
                $('.addressBlock').each(function() {
                    if (!$(this).hasClass('hide')) {
                        $(this).addClass('hide');
                    }
                });
            }
        }
        if (condition) {
            this.addAddressHistoryLength();
        }
        if (this.multipleAddresses) {
            let totalMonths = 0;
            this.myAddresses.forEach((address) => {
                totalMonths += (parseInt(address.years, 10) ? parseInt(address.years, 10) * 12 : 0) +
                    parseInt(address.months, 10);
            });
            if (totalMonths >= this.requiredHistory) {
                this.showBlocks([]);
                this.removeRequiredFields();
            } else {
                this.showBlocks([this.searchAddressBlock, this.searchAddressDurationBlock]);
                this.clearSearchForm();
                this.clearManualForm();
                this.toggleRequiredFields();
            }
        } else if (this.myAddresses.length > 0) {
            this.showBlocks([]);
            this.removeRequiredFields();
        } else {
            this.showBlocks([this.searchAddressBlock, this.searchAddressDurationBlock]);
        }
        this.checkForNonStandardPostcode();
    }

    checkDisableAddressButton(button, addressInputs) {
        let self = this,
            disabled = 0,
            billingAddressYears = document.getElementById('billing_address_search_form_months_years'),
            billingAddressMonths = document.getElementById('billing_address_search_form_months_months');
        addressInputs.forEach((el) => {
            if (disabled == 1) {
                return;
            }
            if (!el.validity.valid || (!el.value && el.hasAttribute('required'))) {
                button.dataset.isPending = false;
                self.elementClassHandler.remove(button, 'pulse');
                button.setAttribute('disabled', 'disabled');
                disabled = 1;
            }
        });
        if (disabled !== 1) {
            button.dataset.isPending = true;
            button.removeAttribute('disabled');
            self.elementClassHandler.add(button, 'pulse');
            if (billingAddressYears && !(window.getComputedStyle(billingAddressYears).display === 'none') && billingAddressMonths && !(window.getComputedStyle(billingAddressMonths).display === 'none')) {
                let billingAddressYearsVal = billingAddressYears.value,
                    billingAddressMonthsVal = billingAddressMonths.value;
                if ((billingAddressYearsVal != null && billingAddressYearsVal != '' && billingAddressYearsVal != '0') || (billingAddressMonthsVal != null && billingAddressMonthsVal != '' && billingAddressMonthsVal != '0')) {
                    self.elementClassHandler.add(button, 'highlight-button');
                } else {
                    self.elementClassHandler.remove(button, 'highlight-button');
                }
            }
        }
    }

    clearFields(fields, formElement) {
        fields.forEach((fieldName) => {
            let field = document.querySelector(this.selectors.nameAttr(formElement + fieldName));
            if (field) {
                field.value = '';
                this.elementClassHandler.remove(field.parentNode, 'is-dirty');
                this.elementClassHandler.remove(field.parentNode, 'is-valid');
                this.elementClassHandler.remove(field.parentNode, 'is-invalid');
            }
        });
    }

    clearManualForm() {
        this.clearFields(['[property]', '[houseNumber]', '[street]', '[locality]', '[town]', '[county]', '[postcode]',
            '[months][years]', '[months][months]'], this.manualForm);

        if (document.querySelector(this.selectors.dataAttr(this.manualAddressIndex))) {
            document.querySelector(this.selectors.dataAttr(this.manualAddressIndex)).value = '';
        }
        this.clearAddressDeleteMessage();
    }

    clearSearchForm() {
        this.clearAddressSearchMessage();
        this.clearFields(['[houseNumberName]', '[postcode]', '[months][years]', '[months][months]'], this.searchForm);
        componentHandler.upgradeDom();
        this.setupSearchInputListener();
    }

    setAddressSearchMessage() {
        const element = document.querySelector(this.selectors.dataAttr(this.addressSearchMessage));
        if (!this.matchingAddresses.length) {
            element.innerHTML = '<span class="brand-pale-red-icon home pull-left"></span><p class="regular-font">Sorry, we\'re unable to find your address. Please try again or alternatively, <a class="brand-hi-sky-text" href="#" data-address-id="billing_address_manual_link">enter your address manually</a>.</p>';
            this.elementClassHandler.alertError(element);
            this.elementClassHandler.show(element);
        } else if (this.matchingAddresses.length > 1) {
            if (this.multipleAddresses) {
                let addressIndex = this.myAddresses.length;
                element.innerHTML = addressIndex == 0 ? 'Please select your address from the list.' : 'Please select your previous address from the list.';
            } else {
                element.innerHTML = 'Please select an address from the list.';
            }
            this.elementClassHandler.removeAlerts(element);
            this.elementClassHandler.show(element);
        }
    }

    clearAddressSearchMessage() {
        const element = document.querySelector(this.selectors.dataAttr(this.addressSearchMessage));
        this.elementClassHandler.hide(element);
        element.innerHTML = '';
    }

    clearAddressDeleteMessage() {
        const element = document.querySelector(this.selectors.dataAttr(this.errorMessage));
        this.elementClassHandler.hide(element);
        element.innerHTML = '';
    }

    checkForNonStandardPostcode() {
        if (this.myAddresses.length) {
            this.checkPostcode(this.myAddresses[0].postcode);
        } else {
            this.actionPostcode(false);
        }
    }

    checkPostcode(postcode) {
        this.loadingOverlay.taskStarted();
        this.requestHandler.post(
            constants.CHECKOUTPATH + '/delivery-address/isnonstandard',
            {
                'postcode': postcode
            },
            this.checkPostcodeCallBack.bind(this)
        );
    }

    checkPostcodeCallBack(response) {
        this.actionPostcode(response.result);
        this.loadingOverlay.taskFinished();
    }

    actionPostcode(nonstandard) {
        if (nonstandard) {
            this.showElementIfExists(this.nonStandardPostcodeMessage);
            this.hideElementIfExists(this.slotPicker);
        } else {
            this.hideElementIfExists(this.nonStandardPostcodeMessage);
            this.showElementIfExists(this.slotPicker);
        }
    }

    hideElementIfExists(selector) {
        const element = document.querySelector(this.selectors.dataAttr(selector));
        if (element) {
            this.elementClassHandler.hide(element);
        }
    }

    showElementIfExists(selector) {
        const element = document.querySelector(this.selectors.dataAttr(selector));
        if (element) {
            this.elementClassHandler.show(element);
        }
    }

    readConfig() {
        const configString = this.container.getAttribute(this.configAttribute);
        if (!configString) {
            return;
        }
        let config = JSON.parse(configString);
        if (!config) {
            return;
        }
        if (config.hasOwnProperty('requiredHistory')) {
            this.requiredHistory = config.requiredHistory;
        }
        if (config.hasOwnProperty('multipleAddresses')) {
            this.multipleAddresses = config.multipleAddresses;
        }
    }

    constructManualFormDataFromAddressLookup(address) {
        let propertyConstructArray = this.fetchPropertyConstructArray(address);
        let stub = `${this.manualFormPrefix}`,
            data = {
                [stub + '[property]']: this.constructProperty(address, propertyConstructArray),
                [stub + '[houseNumber]']: this.fetchBuildingNumberOrName(address),
                [stub + '[street]']: address['street'] ? address['street'] : '',
                [stub + '[locality]']: '',
                [stub + '[town]']: address['town'] ? address['town'] : '',
                [stub + '[county]']: address['stateRegion'] ? address['stateRegion'] : '',
                [stub + '[postcode]']: address['postcode'] ? address['postcode'] : '',
                [stub + '[_token]']: this.manualFormToken
            };

        if (address.hasOwnProperty('years')) {
            // what do we do about this
            data[stub + '[months][years]'] = address['years'];
            data[stub + '[months][months]'] = address['months'];
        }
        return data;
    }

    constructProperty(address, fieldsToConcatenate) {
        let propertyComponents = [];
        const keys = Object.keys(address);

        keys.forEach((key) => {
            if (fieldsToConcatenate.includes(key)) {
                propertyComponents.push(address[key]);
            }
        });
        return propertyComponents.join(', ');
    }

    fetchPropertyConstructArray(address) {
        let buildingName = ['organisation', 'subBuilding'];
        if (address['buildingNumber'] && address['buildingNumber'] !== '') {
            buildingName = ['organisation', 'subBuilding', 'buildingName'];
        }
        return buildingName;
    }

    fetchBuildingNumberOrName(address) {
        return address['buildingNumber'] ? address['buildingNumber'] : address['buildingName'];
    }

    setupPostCode() {
        // $('#billing_address_search_form_postcode, #billing_address_manual_form_postcode, #delivery_address_search_form_postcode, #delivery_address_manual_form_postcode').bind('input propertychange', function(e) {

        $(document).on('input propertychange', '#billing_address_search_form_postcode, #billing_address_manual_form_postcode, #delivery_address_search_form_postcode, #delivery_address_manual_form_postcode', function(e) {
            // var checkPostCode = '';
            const jeGyPattern = /^(JE|GY)/;
            const imPattern = /^(IM1|IM2|IM3|IM4|IM5|IM6|IM7|IM8|IM9|IM86|IM87|IM99)/;
            let postcode = $(this);
            let checkPostCode = $(this);
            if (postcode.val().length >= 2 && jeGyPattern.test(postcode.val().toUpperCase())) {
                if (!$('span').hasClass('errorMessageJGPostCode')) {
                    postcode.after('<span class="errorMessageJGPostCode" style="box-sizing: border-box;width: 100%;color: #d0021b;font-size: 14px;">We do not deliver to JE or GY postcodes</span>');
                }
                $('#details-form').validator('update');
                setTimeout(function() {
                    postcode.val('');
                    $('.errorMessageJGPostCode').fadeTo(0, 2000);
                    $('.errorMessageJGPostCode').remove();
                }, 5000);
                e.preventDefault();
            } else {
                let searchStoresEl = document.querySelector('[data-stores-search]');
                if (searchStoresEl && $(this).val().length >= 3) {
                    const el = document.getElementById('search-stores-input');
                    el.dispatchEvent(new Event('input', $('#search-stores-input').val($(this).val())));
                }
                $('#details-form').validator('update');
            }
            // console.log(checkPostCode.val());
            if (checkPostCode.val().length >= 2 && imPattern.test(checkPostCode.val().toUpperCase())) {
                if (!$('span').hasClass('errorMessagePostCode')) {
                    postcode.after('<span class="errorMessagePostCode" style="box-sizing: border-box;width: 100%;color: #d0021b;font-size: 14px;"> Sorry, we are unable to deliver to this postcode. Please try another address. </span>');
                }
                $('#details-form').validator('update');
                setTimeout(function() {
                    $('.errorMessagePostCode').fadeTo(0, 2000);
                    checkPostCode.val('');
                    $('.errorMessagePostCode').remove();
                }, 5000);
                e.preventDefault();
            } else {
                let searchStoresEl = document.querySelector('[data-stores-search]');
                if (searchStoresEl && $(this).val().length >= 3) {
                    const el = document.getElementById('search-stores-input');
                    el.dispatchEvent(new Event('input', $('#search-stores-input').val($(this).val())));
                }
                $('#details-form').validator('update');
            }
        });
    }
}
